import { Status } from './enums/status.enum';

export function isNewUser(status: string | null) {
  return (+status! as Status) === Status.New;
}
